import "@fontsource/jetbrains-mono";
import "@fontsource-variable/inter";
import "@fontsource-variable/instrument-sans";

import { Rebase, RebaseAuth, useRebaseAuthController } from "@rebasepro/app";
import { RebaseCMS, RebaseShell } from "@rebasepro/cms";
import { ErrorBoundary } from "@rebasepro/ui";
import { RebaseStudio } from "@rebasepro/studio";
import { createRebaseClient } from "@rebasepro/client";
import { collections } from "virtual:rebase-collections";

// The admin panel at admin.songbuzz.tv. It is served by the same project as the game, so the API is on its own
// origin and VITE_API_URL is empty in a deployed build; `rebase dev` sets it to the local backend.
const API_URL = import.meta.env.VITE_API_URL;
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

// One client for the page, created when this module loads: inside a component, StrictMode would build a second one.
const rebaseClient = createRebaseClient({
    baseUrl: API_URL,
    auth: { authFlowMode: "cookie" }
});

export function App() {
    const authController = useRebaseAuthController({
        client: rebaseClient,
        googleClientId: GOOGLE_CLIENT_ID
    });

    return (
        <ErrorBoundary fullPage>
            <Rebase
                client={rebaseClient}
                authController={authController}
            >
                <RebaseAuth />
                <RebaseCMS
                    collections={collections}
                />
                {/* SQL, schema and storage, for what the collections don't show (the Daily Gig board, the AI spend) */}
                <RebaseStudio/>
                <RebaseShell title="SongBuzz"/>
            </Rebase>
        </ErrorBoundary>
    );
}
